import ComponentManager from '@/Management/ComponentManager';
import TreeViewViewModel from '@/ViewModels/Controls/TreeViewViewModel';
import HeaderViewModel from '@/ViewModels/Views/HeaderViewModel';
import LinkViewModel from '@/ViewModels/Controls/LinkViewModel';
import DropDownListViewModel from '@/ViewModels/Controls/DropDownListViewModel';
import LabelViewModel from '@/ViewModels/Controls/LabelViewModel';
import ImageViewModel from '@/ViewModels/Controls/ImageViewModel';
import StorageHelper from '@/Utility/StorageHelper';

export default class ReducedHeaderViewModel extends HeaderViewModel {

    constructor(params: any) {
        super(params);
    }

    /**
     * @override
     */
    protected createApplicationNameLinkViewModel(): LinkViewModel {
        const base = super.createApplicationNameLinkViewModel();
        base.isEnabled(false);

        return base;
    }

    /**
     * @override
     */
    protected initSearch(): void {
        // nothing todo
    }

    /**
     * @override 
     */
    protected createShowFavoritesLinkViewModel(): LinkViewModel {
        return null;
    }

    /**
     * @override
     */
    protected createFavoriteTree(): TreeViewViewModel {
        return null;
    }

    /**
     * @override
     */
    protected createLogoutLinkViewModel(): LinkViewModel {
        return null;
    }

    /**
     * @override 
     */
    protected createTogglePaneLinkViewModel(): LinkViewModel {
        StorageHelper.set('WireframeExpanded', false);
        return null;
    }

    /**
     * @override 
     */
    protected createHomeLinkViewModel(): LinkViewModel {
        return null;
    }

    /**
     * @override
     */
    protected shouldInitTasks(): boolean {
        return false;
    }

    /**
     * @override 
     */
    protected createShowSettingsLinkViewModel(): LinkViewModel {
        return null;
    }
  

    /**
     * @override
     */
    protected createUserNameLabelViewModel(): LabelViewModel {
        return null;
    }

    /**
     * @override
     */
    protected createPrincipalDropDownListViewModel(): DropDownListViewModel {
        return null;
    }

    /**
     * @override
     */
    protected createPrincipalLogoViewModel(): ImageViewModel {
        return null;
    }
}

ComponentManager.setViewModel('ReducedHeader', ReducedHeaderViewModel, 'RADPresentation.HTMLClient.DefaultViewExtensions');